module.exports = __webpack_public_path__ + "img/hr-heated-corner-down-right-5.8ad861d9.png";